import { Link } from "react-router-dom";
import SectionHead from "../components/SectionHead";
import FAQAccordion from "../components/FAQAccordion";
import { Reveal } from "../components/motion";
import { useLang } from "../i18n";

const FAQPage = () => {
    const { t } = useLang();
    return (
        <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8 lg:py-24">
            <SectionHead
                eyebrow={t.faqPage.eyebrow}
                title={t.faqPage.title}
                sub={t.faqPage.sub}
                testid="faq-page-title"
                align="center"
            />
            <FAQAccordion />
            <Reveal className="mt-12 text-center">
                <p className="text-[15px] text-[#525B53]">{t.faqPage.noAnswer}</p>
                <Link
                    to="/contacto"
                    data-testid="faq-page-cta"
                    className="mt-4 inline-flex rounded-full bg-terracotta px-8 py-3.5 text-[15px] font-bold text-cream shadow-lg shadow-terracotta/25 transition-[background-color,transform] duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5"
                >
                    {t.faqPage.cta}
                </Link>
            </Reveal>
        </main>
    );
};

export default FAQPage;
